import CyclesList from "./CyclesList";

export default {
    list: CyclesList,
};
